
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb068"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb068"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $2BiDy = parcelRequire("2BiDy");

var $62Aqy = parcelRequire("62Aqy");

var $9B4XW = parcelRequire("9B4XW");
const $79cbb156684b404c$var$loginInfo = document.querySelector("#login-info");
const $79cbb156684b404c$var$logoutButton = document.querySelector("#logout-button");
document.addEventListener("DOMContentLoaded", ()=>{
    const accessToken = (0, $62Aqy.getAccessToken)();
    const refreshToken = (0, $2BiDy.storage).getSessionData("refreshToken");
    if (accessToken && refreshToken && (0, $62Aqy.getLoggedInUserId)()) (0, $9B4XW.updateLoginState)();
    $79cbb156684b404c$var$authIframe.src = (0, $9B4XW.getLoginIframeSource)();
    (0, $9B4XW.setupEventListenersForIframe)($79cbb156684b404c$var$authIframe);
});
const $79cbb156684b404c$var$toggleLoginModalButton = document.querySelector("#toggle-login-modal-button");
const $79cbb156684b404c$var$authIframe = document.querySelector("#auth-iframe");
$79cbb156684b404c$var$toggleLoginModalButton.addEventListener("click", ()=>{
    const isHidden = window.getComputedStyle($79cbb156684b404c$var$authIframe).getPropertyValue("display") === "none";
    $79cbb156684b404c$var$authIframe.style.display = isHidden ? "block" : "none";
});
$79cbb156684b404c$var$logoutButton.addEventListener("click", ()=>{
    (0, $62Aqy.clearLogin)();
    $79cbb156684b404c$var$logoutButton.style.display = "none";
    $79cbb156684b404c$var$loginInfo.innerHTML = "Not logged in";
});


//# sourceMappingURL=demo.c81669e1.js.map
